import { FORM_POST_REDIRECT_SUBMIT_BUTTON_ID } from '@constants';

import { getSavedTokenDataFromStorage } from '../../helpers/sessionHelper';

export const FormPostRedirect = () => {
	const tokenOAuth = getSavedTokenDataFromStorage<string>('tokenOAuth') ?? '';
	const mseOTT = getSavedTokenDataFromStorage<string>('mseOTT') ?? '';
	const returnUrl = getSavedTokenDataFromStorage<string>('returnUrl');
	const returnEncodedUrl = decodeURIComponent(returnUrl ? returnUrl : '');

	return (
		<form action={returnEncodedUrl} method="post" style={{ display: 'none' }}>
			<input type="hidden" name="JWTToken" value={tokenOAuth} />
			<input type="hidden" name="AdditionalData[MSE_ott_ext_app]" value={mseOTT} />
			<button id={FORM_POST_REDIRECT_SUBMIT_BUTTON_ID} type="submit">
				Send
			</button>
		</form>
	);
};
